/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 *   let quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.__acezoneCustomJsVersion = '2026-06-24-withdrawal-floating-labels';




 


const frontpage = document.querySelector('.template-index'); // Be sure we're on the frontpage.
const collection = document.querySelector('.template-collection');

if (frontpage) {
  window.onload = setTimeout(function(){ document.querySelector(".preloader").style.display = "none"; }, 50);

  const ptl = gsap.timeline ({
    duration: 0.1
  })

  ptl.from (".video-wrapper", {
      xPercent:-50, left:"50%",
      opacity: 1,
      duration: 1 
  }, 'hero');

  ptl.from (".hero-pattern", {
      x: '-80vw', 
      duration: 1
  }, 'hero');


  gsap.from ('.left-col', {
      duration: 0.9,
      delay: 0.5,
      opacity: 0,
      ease: "power4.outout",
      x: 50
  })

} else  {
  window.onload = setTimeout(function(){ document.querySelector(".preloader").style.display = "none"; }, 700);
}

if (frontpage || collection ) {
  document.addEventListener( 'DOMContentLoaded', function() {
    let splide = new Splide( '#product-card-slider', {
      destroy: true,

      // Important anti-skip tweaks
      flickMaxPages: 1,
      flickPower: 1,
      perMove: 1,
      dragMinThreshold: { touch: 10, mouse: 5 },
      waitForTransition: true,

      breakpoints: {
    
        1007: {
          type: 'loop',
          perPage: 2,
          perMove: 1,
          destroy: false,
          pagination: false,
          focus: 'center',
          trimSpace: true,
          lazyLoad: true,
          autoplay: true,
          interval: 5000,
          fixedWidth: 380,
        }, 
        640: {
          perPage: 3,
          perMove: 1,
          gap: 20,
          fixedWidth: 240,
        },
      }
      
    });

    splide.mount();
  } );
};





 const arise = document.querySelector('.a-rise');
 const alive = document.querySelector('.a-live');







document.addEventListener( 'DOMContentLoaded', function () {
  if (arise || alive) {
  gsap.registerPlugin(ScrollTrigger)

  console.clear();
  /* The encoding is super important here to enable frame-by-frame scrubbing. */

  // ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -movflags faststart -vcodec libx264 -crf 23 -g 1 -pix_fmt yuv420p output.mp4
  // ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -vf scale=960:-1 -movflags faststart -vcodec libx264 -crf 20 -g 1 -pix_fmt yuv420p output_960.mp4


    let videoScroll = document.querySelector(".video-scroll"),
        frameNumber = 0,
        src = videoScroll.currentSrc || videoScroll.src


    videoScrollTL = gsap.timeline({
      defaults: { duration: 4 },
      scrollTrigger: {
        trigger: ".video-container",
    
        start: "0 center",
        end: "600 center",
        scrub: true, 
        markers: false,
        onUpdate: self => {
          frameNumber = self.progress / 14 * 100 ; //this takes fine tuning divide your videos FPS by two. My video's FPS was 30, 14 was the sweet spot. -1 fixes an issue on safari where the video disappears at the end of the scrollTrigger
          videoScroll.currentTime = frameNumber;
        }
      }
    });		    

    /* Make sure the video is 'activated' on iOS */
    function once(el, event, fn, opts) {
      let onceFn = function (e) {
        el.removeEventListener(event, onceFn);
        fn.apply(this, arguments);
      };
      el.addEventListener(event, onceFn, opts);
      return onceFn;
    }			    

    once(document.documentElement, "touchstart", function (e) {
      videoScroll.play(); 
      videoScroll.pause();
    });

    //make sure video has loaded
    once(videoScroll, "loadedmetadata", function () {
      videoScrollTL.fromTo(videoScroll, { currentTime: 0 }, { currentTime: videoScroll.duration - 0.10 });
    });

    //When first coded, the Blobbing was important to ensure the browser wasn't dropping previously played segments, but it doesn't seem to be a problem now. Possibly based on memory availability?
    setTimeout(function () {
      if (window["fetch"]) {
        fetch(src).then(function (response) {
          return response.blob();
        }).then(function (response) {
          let blobURL = URL.createObjectURL(response);
          let t = videoScroll.currentTime;
          once(document.documentElement, "touchstart", function (e) {
            videoScroll.setAttribute("src", blobURL);
            videoScroll.currentTime = t + 0.01;
          });
        });
      }
    }, 0);

  }



  // Progressbar

  const progressBar = document.querySelector('.progressBar');
  const section = document.querySelector('.body-container');

  const scrollProgressBar = () => {
    let scrollDistance = -(section.getBoundingClientRect().top);
    let progressPercentage =
      (scrollDistance /
        (section.getBoundingClientRect().height -
          document.documentElement.clientHeight)) * 100;

    let val = Math.floor(progressPercentage);
    progressBar.style.width = val + '%';

    if (val < 0) {
      progressBar.style.width = '0%';
    }
  };

  window.addEventListener('scroll', scrollProgressBar);
});


document.addEventListener('click', function(event) {
  var checkoutTarget = event.target.closest('[name="checkout"], [name="goto_pp"], [name="goto_gc"]');
  if (!checkoutTarget) return;

  var agreeCheckbox = document.getElementById('agree');
  if (!agreeCheckbox || agreeCheckbox.checked) return;

  event.preventDefault();
  alert('You must agree with the terms and conditions of sales to check out.');
}, true);



// var BrowserDetect = {
//   init: function () {
//       this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
//       this.version = this.searchVersion(navigator.userAgent)
//           || this.searchVersion(navigator.appVersion)
//           || "an unknown version";
//       this.OS = this.searchString(this.dataOS) || "an unknown OS";
//   },
//   searchString: function (data) {
//       for (var i=0;i<data.length;i++)    {
//           var dataString = data[i].string;
//           var dataProp = data[i].prop;
//           this.versionSearchString = data[i].versionSearch || data[i].identity;
//           if (dataString) {
//               if (dataString.indexOf(data[i].subString) != -1)
//                   return data[i].identity;
//           }
//           else if (dataProp)
//               return data[i].identity;
//       }
//   },
//   searchVersion: function (dataString) {
//       var index = dataString.indexOf(this.versionSearchString);
//       if (index == -1) return;
//       return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
//   },
//   dataBrowser: [
//       {
//           string: navigator.userAgent,
//           subString: "Chrome",
//           identity: "Chrome"
//       },
//       {     string: navigator.userAgent,
//           subString: "OmniWeb",
//           versionSearch: "OmniWeb/",
//           identity: "OmniWeb"
//       },
//       {
//           string: navigator.vendor,
//           subString: "Apple",
//           identity: "Safari",
//           versionSearch: "Version"
//       },
//       {
//           prop: window.opera,
//           identity: "Opera",
//           versionSearch: "Version"
//       },
//       {
//           string: navigator.vendor,
//           subString: "iCab",
//           identity: "iCab"
//       },
//       {
//           string: navigator.vendor,
//           subString: "KDE",
//           identity: "Konqueror"
//       },
//       {
//           string: navigator.userAgent,
//           subString: "Firefox",
//           identity: "Firefox"
//       },
//       {
//           string: navigator.vendor,
//           subString: "Camino",
//           identity: "Camino"
//       },
//       {        // for newer Netscapes (6+)
//           string: navigator.userAgent,
//           subString: "Netscape",
//           identity: "Netscape"
//       },
//       {
//           string: navigator.userAgent,
//           subString: "MSIE",
//           identity: "Explorer",
//           versionSearch: "MSIE"
//       },
//       {
//           string: navigator.userAgent,
//           subString: "Gecko",
//           identity: "Mozilla",
//           versionSearch: "rv"
//       },
//       {         // for older Netscapes (4-)
//           string: navigator.userAgent,
//           subString: "Mozilla",
//           identity: "Netscape",
//           versionSearch: "Mozilla"
//       }
//   ],
//   dataOS : [
//       {
//           string: navigator.platform,
//           subString: "Win",
//           identity: "Windows"
//       },
//       {
//           string: navigator.platform,
//           subString: "Mac",
//           identity: "Mac"
//       },
//       {
//              string: navigator.userAgent,
//              subString: "iPhone",
//              identity: "iPhone/iPod"
//       },
//       {
//           string: navigator.platform,
//           subString: "Linux",
//           identity: "Linux"
//       }
//    ]
  
//   };
//   BrowserDetect.init();
//   if (BrowserDetect.browser == 'Safari') {

//       document.getElementById('hero-video').style.display = 'none';
//       document.getElementById('firedust-video').style.display = 'none';
//       document.getElementById('hero-pattern').style.display = 'none';
//       document.getElementById('hero-video-safari').style.display = 'block';
//       document.getElementById('video-wrapper').classList.add("alfa-for-safari");
//   } else {

//   }

const videoSlider = document.querySelector('.video_slider_section');


    
if (videoSlider) {
  document.addEventListener( 'DOMContentLoaded', function() {
    let splide = new Splide( '#video-slider', {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      pagination: false,
      focus: 'center',
      trimSpace: true,
      lazyLoad: true,
      autoplay: true,
      interval: 5000,
      autoWidth: true,
      gap: 20,
      video: {
        loop         : true,
        mute         : true
      },
    });

    splide.mount( window.splide.Extensions );
  });
};

/*
document.addEventListener("DOMContentLoaded", function () {
  var accordions = document.querySelectorAll(".ProductMeta__Description.accordionDescription");

  accordions.forEach(function (accordion) {
    var rte = accordion.querySelector(".Rte");
    var separator = accordion.querySelector(".accordionSeperator");

    if (!rte || !separator) return;

    // Measure content height
    var contentHeight = rte.scrollHeight;

    if (contentHeight <= 120) {
      // Too short: no accordion needed
      accordion.style.maxHeight = "10000px";
      accordion.style.cursor = "text";   // remove pointer
      if (separator) separator.remove();
      return;
    }

    // Accordion logic for taller content
    accordion.addEventListener("click", function () {
      accordion.classList.toggle("expanded");
    });
  });
});
*/
document.addEventListener("click", function (e) {
  const acc = e.target.closest(".ProductMeta__Description.accordionDescription");
  if (!acc) return;

  // Only toggle when clicking the "header"/separator area (adjust selector if needed)
  if (!e.target.closest(".accordionSeperator")) return;

  const rte = acc.querySelector(".Rte");
  const separator = acc.querySelector(".accordionSeperator");
  if (!rte || !separator) return;

  // Decide if accordion needed (recompute so it works after load too)
  const contentHeight = rte.scrollHeight;
  if (contentHeight <= 120) {
    acc.style.maxHeight = "none";
    acc.style.cursor = "text";
    separator.remove();
    return;
  }

  // IMPORTANT: prevent other theme click handlers from undoing this
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

  acc.classList.toggle("expanded");

  // Optional: make the visual expansion reliable even if CSS is flaky
  acc.style.maxHeight = acc.classList.contains("expanded") ? (contentHeight + "px") : "120px";
}, true); // <-- capture phase

// EU Withdrawal form (/a/withdrawal): floating labels.
// 1) The app renders a <label> above each field with no placeholder, so copy the
//    label text (minus the required asterisk) onto the input as a placeholder —
//    that's the "field name shown while empty" state.
// 2) Toggle a `.anv-field--filled` class on the field whenever it has a value, so
//    custom.css can float the label up. We do this in JS rather than relying on
//    CSS :has()/:placeholder-shown, which aren't supported everywhere.
(function () {
  var page = document.querySelector(".anv-withdrawal-page");
  if (!page) return;
  page.querySelectorAll(".anv-withdrawal-form__field").forEach(function (field) {
    var label = field.querySelector("label");
    var control = field.querySelector("input, textarea");
    if (!label || !control) return;

    if (!control.getAttribute("placeholder")) {
      var text = (label.textContent || "").replace("*", "").trim();
      if (text) control.setAttribute("placeholder", text);
    }

    var sync = function () {
      field.classList.toggle("anv-field--filled", control.value.trim() !== "");
    };
    control.addEventListener("input", sync);
    control.addEventListener("change", sync);
    control.addEventListener("blur", sync);
    sync(); // handle autofilled / prefilled values on load
  });
})();

// ─── Mini-cart "Complete your setup" cross-sell (Phase 2) ────────────────────
// A delegated click handler so it keeps working after the cart drawer
// re-renders (the theme swaps the whole .Cart node on every refresh). Adding a
// suggestion posts its variant to /cart/add.js and dispatches `product:added`
// on document — the same hook the PDP add-to-cart uses (see assets/pdp.js) —
// which the theme's CartSection listens for to re-render the drawer and keep it
// open. We deliberately reuse that path rather than inventing a new one.
(function () {
  if (window.__acezoneCartXsellBound) return;
  window.__acezoneCartXsellBound = true;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-xsell-add]");
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add("is-loading");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json"
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw j; });
        return res.json();
      })
      .then(function (line) {
        // Re-render + (idempotently) open the drawer via the theme's hook.
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: { variant: { id: (line && line.variant_id) || variantId }, quantity: 1 }
          })
        );
      })
      .catch(function (err) {
        console.error("[cart-xsell] add failed", err);
        btn.disabled = false;
        btn.classList.remove("is-loading");
      });
  });
})();
